import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import CircleCheckIcon from '../icons/CircleCheckIcon';
import sizes from './sizes';

const ApproveButton = ({
  disabled,
  onClick,
  title,
  id,
  className,
  size,
  dataTestId,
}) => {
  return (
    <CircleButton
      id={id}
      size={size}
      className={className}
      color="green"
      disabled={disabled}
      onClick={onClick}
      title={title}
      dataTestId={dataTestId || "approveButton"}
    >
      <CircleCheckIcon />
    </CircleButton>
  );
};

ApproveButton.propTypes = {
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.values(sizes)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ApproveButton.defaultProps = {
  size: sizes.normal,
  disabled: false,
  title: '',
};

export default ApproveButton;
